import { render, staticRenderFns } from "./MainBox.vue?vue&type=template&id=beec796c&scoped=true&"
import script from "./MainBox.vue?vue&type=script&lang=js&"
export * from "./MainBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beec796c",
  null
  
)

export default component.exports